import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BrowserModule } from '@angular/platform-browser'
import { Routes, RouterModule } from '@angular/router'
import { AuthGuard } from './_guards'
import { LoginComponent } from './login/login.component'
import { HomeComponent } from './home/home.component'
import { DashboardComponent } from './dashboard/dashboard.component'

import { UccComponent } from './dashboard/ucc/ucc.component'

import { AlarmComponent } from './alarm/alarm.component'

import { AlarmFuelComponent } from './alarm/alarmFuel/alarmFuel.component'
import { FuelAlertComponent } from './alarm/fuelAlert/fuelAlert.component'

import { AlarmSummaryComponent } from './alarm/alarmSummary/alarmSummary.component'

//KCC
import { KccComponent } from './crm/kcc/kcc.component'

import { KccLkoComponent } from './crm/kccLko/kccLko.component'
import { ComplainComponent } from './crm/complain/complain.component'
import { ProjectComponent } from './dashboard/project/project.component'

import { ComplainDashBoardComponent } from './dashboard/complain/complain.component'
import { TargetDashBoardComponent } from './dashboard/target/targetDashboard.component'
import { TonnageDashBoardComponent } from './dashboard/tonnage/tonnageDashboard.component'

import { ReportsComponent } from './reports/reports.component'

import { StopComponent } from './maptracker/stop/stop.component'
import { MaptrackerComponent } from './maptracker/maptracker.component'
import { AreaComponent } from './maptracker/area/area.component'
import { BeatComponent } from './maptracker/area/beat.component'
import { AlarmsComponent } from './maptracker/vehicles/alarms.component'
import { VehiclesComponent } from './maptracker/vehicles/vehicles.component'
import { mcgVehiclesComponent } from './maptracker/vehicles/mcgVehicles.component'
import { SecondaryOpsComponent } from './maptracker/vehicles/secondaryOps.component'

// maptrackerDashboardComponent

import { maptrackerDashboardComponent } from './maptracker/maptracker-dashboard/maptrackerDashboard.component'

import { AdminComponent } from './admin/admin.component'
import { EmployeeComponent } from './admin/employee/empMngt/employee.component'

import { DriverComponent } from './admin/employee/empMngt/driver.component'
import { EmpComponent } from './admin/employee/emp.component'
import { SuperAdminComponent } from './superAdmin/superAdmin.component'
import { ServerMonitoring } from './superAdmin/users/serverMonitoring.component'
import { UccUserComponent } from './superAdmin/users/uccUser.component'
import { UsersComponent } from './superAdmin/users/users.component'

import { AccessDetailsComponent } from './superAdmin/users/accessDetails.component'
//for admin
//import{vehicleComponent} from './admin/employee/vehicles/vehicles.component';
import { EntityComponent } from './admin/entity/entityMngt/entity.component'
import { EntComponent } from './admin/entity/ent.component'
import { HrmsComponent } from './admin/hrms/hrms.component'
import { HrmsEmployeeComponent } from './admin/hrms/hrmsMnt/hrmsEmployee.component'

import { TargetComponent } from './admin/target/target.component'
import { TargetMasterComponent } from './admin/target/targetMaster/targetMaster.component'
//Khatta Component

//import{newVehiclesComponent} from './admin/employee/newVehicles/newVehicles.component';
//import{addNewVehiclesComponent} from './admin/user/vehicles/addVehicles/addVehicles.componont'
import { AddNewVehiclesComponent } from './admin/vehicles/vehicleMngt/vehicles.AddNewVehicles'
import { VehicleComponent } from './admin/vehicles/vehicleMngt/vehicles.component'
import { VehComponent } from './admin/vehicles/veh.component'

//TS MAPPING(8-03-2019)
import { TsComponent } from './maintenance/TS/transferStation.component'
import { TsMasterComponent } from './maintenance/TS/tsMaster/tsMaster.component'

//MAINTENANCE PART MANAGEMENT
import { PartComponent } from './maintenance/part/part.component'
import { PartMasterComponent } from './maintenance/part/partMaster/partMaster.component'

import { PartDashboardComponent } from './maintenance/part/PartDashboard/PartDashboard.component'

// engine Oil
import { EngineoilComponent } from './maintenance/EngineOil/ebgineOil/engineoilfile.component'
import { EngineComponent } from './maintenance/EngineOil/engineOil.component'

import { VendorMasterComponent } from './maintenance/part/vendorMaster/vendorMaster.component'

import { invoiceAndChallanComponent } from './maintenance/part/InvoiceAndChallan/invoiceAndChallan.component'

//Report

import { UccReportsComponent } from './reports/uccReport/uccReport.Component'
import { BulkCollectionReportComponent } from './reports/uccReport/bulkCollectionReport.Component'
import { CollectionAnalysisReport } from './reports/uccReport/collectionAnalysisReport.Component'

import { CollectionSummaryComponent } from './reports/uccReport/collectionSummaryReport.Component'
// CRM
import { CRMComponent } from './crm/crm.component'
import { EntitySummaryReportComponent } from './reports/entityReport/entitySummaryReport.component'

// consumer
import { ConsumerListComponent } from './crm/kcc/consumer/consumerList/consumerList.component'
import { InvoiceListComponent } from './crm/kcc/invoice/invoiceList/invoiceList.component'
import { CreateInvoiceComponent } from './crm/kcc/invoice/createInvoice/createInvoice.component'

import { ConsumerListLkoComponent } from './crm/kccLko/consumerLko/consumerListLko/consumerListLko.component'
import { InvoiceListLkoComponent } from './crm/kccLko/invoiceLko/invoiceListLko/invoiceListLko.component'
import { CreateInvoiceLkoComponent } from './crm/kccLko/invoiceLko/createInvoiceLko/createInvoiceLko.component'
import { PaymentListLkoComponent } from './crm/kccLko/paymentLko/paymentListLko/paymentListLko.component'

import { ComplainListComponent } from './crm/complain/complainList/complainList.component'

import { PaymentListComponent } from './crm/kcc/payment/paymentList/paymentList.component'

//import { ConsumerUccListComponent} from 'app/crm/ucc/uccList/uccList.component';

//KCC Report
import { KccReportsComponent } from './reports/kccReport/kccReport.component'
import { KccSummaryReportComponent } from './reports/kccReport/kccSummaryReport.component'
import { KccCustomerReportComponent } from './reports/kccReport/kccCustomerReport.component'
import { KccDetailReportComponent } from './reports/kccReport/kccDetailReport.component'

//Maintenance
import { VehicleMaintenanceComponent } from './maintenance/vehicleMaintenance/vehicleMnt/vehicleMaintenance.component'
//import {MaintMntComponent} from './maintenance/maintMaster/maintMnt.component';
//import {VehMaintenanceMasterComponent} from './maintenance/maintMaster/master/maintenanceMaster.component';
import { MaintenanceComponent } from './maintenance/maintenance.component'
import { LogbookComponent } from './maintenance/vehicleMaintenance/vehicleMnt/logbook.component'
import { SubstituteComponent } from './maintenance/vehicleMaintenance/vehicleMnt/substitute.component'

import { VehMaintenanceApprovalComponent } from './maintenance/vehicleMaintenance/vehicleMnt/VehicleMaintenanceApproval'

import { jobCardApprovalComponent } from './maintenance/vehicleMaintenance/vehicleMnt/jobCardApproval.component'

import { TSLogbookComponent } from './maintenance/TS/tsMaster/tsLogbook.component'
import { VehicleMaintMntComponent } from './maintenance/vehicleMaintenance/vehicleMnt.component'

import { KccConsolidatedReportComponent } from './reports/kccReport/kccConsolidatedReport.component'

import { EntitysComponent } from './reports/entityReport/entity.component'
/*
   ucc old route
*/
//Mobility Report cr by ram on 24-08-2018
import { MobilityReportComponent } from './reports/mobilityReport/mobility.component'
import { ServiceReportComponent } from './reports/mobilityReport/serviceReport.component'
import { SurveyReportComponent } from './reports/mobilityReport/surveyReport.component'
import { MobilityComponent } from './mobility/mobility.component'
import { MobilityUserComponent } from './mobility/user/mobilityUser.component'
import { KhattaServiceReportComponent } from './mobility/khattaService/khattaServiceReport.component'
import { MappingReportComponent } from './reports/mobilityReport/mappingReport.component'

// vts report

import { VtsReportsComponent } from './reports/vtsReport/vtsReport.component'
import { DriverVehicleComponent } from './reports/vtsReport/driverVehicle.component'
import { DistanceComponent } from './reports/vtsReport/distanceReport.component'
import { VtsDailyReportComponent } from './reports/vtsReport/vtsDailyReport.component'
import { DistanceFuelComponent } from './reports/vtsReport/distanceFuel.component'
import { VtsStatusDailyCountComponent } from './reports/vtsReport/vtsStatusDailyCount.component'

import { routeCoverReportComponent } from './reports/vtsReport/routeCoverReport.component'

import { secondaryReportComponent } from './reports/vtsReport/secondaryReport.component'

//crm report

import { CrmReportComponent } from './reports/crmReport/crmReport.component'
import { ComplainReportComponent } from './reports/crmReport/complainReport.component'

//Report
import { VehiclePlantComponent } from './reports/plant/plant.component'
import { PlantComponent } from './reports/plant/plantReport.component'

import { TransferStationComponent } from './reports/plant/trasnferStation.component'

import { weighbridgeDeatsils } from './reports/plant/weighbridgeDeatsils.component'

import { manualFileUpload } from './reports/plant/manualFileUpload.component'

import { transferStationDataView } from './reports/plant/transferStationDataView.component'

import { transferStationDetails } from './reports/plant/transferStationDetails.component'

import { RdfComponent } from './reports/plant/rdf.component'

import { VehicleReport } from './reports/vehicleReport/vehicleReport.component'
import { PrimaryVehicleReport } from './reports/vehicleReport/primaryVehicleReport.component'
import { PrimaryAssignmentComponent } from './reports/vehicleReport/primaryVehicleAssignment'

import { PrimaryliveTrackingReport } from './reports/vehicleReport/primaryLiveTracking.component'
import { PrimaryVehicleTripReport } from './reports/vehicleReport/primaryVehicleTrip.component'
import { PrimaryUnservedAreaReport } from './reports/vehicleReport/primaryUnservedArea.component'

import { SecondaryReport } from './reports/secondary/secondaryReport.component'
import { SecondaryliveTrackingReport } from './reports/secondary/secondaryLiveTracking.component'
import { SecondaryAssignmentComponent } from './reports/secondary/secondaryAssignment.componant'
import { FuelReportComponent } from './reports/fuel/fuel.component'
import { FuelPurchaseReportComponent } from './reports/fuel/fuelPurchase.component'
import { FuelLooseReportComponent } from './reports/fuel/fuelLoose.component'
import { FuelDistributionReportComponent } from './reports/fuel/fuelDistribution.component'
import { CollectionReportComponent } from './reports/uccReport/couponCollection.component'
import { AttendComponent } from './reports/attendance/attend.component'
import { AttendanceReportComponent } from './reports/attendance/attendance.component'
import { AttendanceDeatilComponent } from './reports/attendance/attendanceDetail.component'
import { ProjectSummaryComponent } from './dashboard/project/projectSummary.component'

//comment

//NEW  CRM UCC
import { CrmUccComponent } from './crm/ucc/ucc.component'
import { GrnComponent } from './crm/ucc/grn/grnList.component'
import { CouponAssignComponent } from './crm/ucc/couponAssignment/couponAssignment.component'
import { CouponCollectionComponent } from './crm/ucc/couponCollection/couponCollection.component'
import { CouponReturnComponent } from './crm/ucc/couponReturn/couponReturn.component'
import { CouponMissingComponent } from './crm/ucc/missingCoupon/missingCoupon.component'
import { InventorySummaryComponent } from './crm/ucc/inventory/inventorySummary.component'
import { InventoryDetailComponent } from './crm/ucc/inventory/inventoryDetail.component'
import { CollectionReceivedComponent } from './crm/ucc/couponReceived/collectionReceived.component'
import { BulkCouponCollectionComponent } from './crm/ucc/bulkCouponCollection/bulkCouponCollection.component'
import { WmDispatchComponent } from './reports/mobilityReport/wmDispatch.component'
import { UccCollectionReportComponent } from './reports/uccReport/uccCollectionReport.Component'
import { UccTransactionComponent } from './reports/uccReport/uccTransaction.component'

import { UccMappingComponent } from './reports/uccReport/uccMapping.Component'

import { UccTransactionReprintComponent } from './reports/uccReport/uccReprintReport.component'
import { UccDefaulterComponent } from './reports/uccReport/uccDefaulter.component'
import { UccDashboardComponent } from './reports/uccReport/uccDashboard.component'
import { UccUsersComponent } from './reports/uccReport/uccUsers.Component'
import { MileageReportComponent } from './reports/fuel/fuelMileage.component'
import { FuelMasterReportComponent } from './reports/fuel/fuelMaster.component'

import { GraphicalVievComponent } from './reports/fuel/graphicalView.component'

/*
 * Maintenance Status
 */
import { VehMaintStatusComponent } from './maintenance/vehicleMaintenance/vehicleMnt/vehMaintenanceStatus.component'
/*
 VEHICLE STOP DETAILS REPORT
*/
import { VehicleStopDetailComponent } from './reports/vtsReport/vehicleStop.component'

/*
|*Cost Control
*/
import { CostControlComponent } from './reports/cost-control/cost-control.component'

import { from } from 'rxjs/observable/from'
import { KccDashboardComponent } from './reports/kccReport/kcc-dashboard.component'
import { CombbinedReportComponent } from './reports/cost-control/combbined-report/combbined-report.component'
import { UccPotentialComponent } from './maptracker/stop/ucc-potential.component'
import { HrComponent } from './reports/hr/hr.component'
import { DoorToDoorComponent } from './reports/doorToDoorMixedwaste/doorToDoor.component'

import { EcokraComponent } from './reports/hr/ecokra.component'
import { PctsComponent } from './reports/plant/pcts.component'
import { TsMaintenanceComponent } from './maintenance/TS/tsMaster/ts-maintenance.component'
import { BankmstComponent } from './crm/kcc/bankmst/bankmst.component'
import { KccReqComponent } from './crm/kcc/kccRequests/kccRequests.component'
import { McgDashboardComponent } from './maptracker/mcg-dashboard/mcg-dashboard.component'
import { VehDashboardComponent } from './maptracker/veh-dashboard/veh-dashboard.component'
import { previousVtsData } from './maptracker/previous-vts-data/previous-vts-data.component'

import { IswmComponent } from './iswmMgt/iswm.component'
// import {  deviceDetailsMgt} from './iswmMgt/deviceDetails/deviceDetails.component';

import { RoutePlanComponent } from './admin/vehicles/vehicleRoutesMngt/routeplan.component'
import { RouteAssignment } from './admin/vehicles/routesAssignments/routeAssignment.component'

import { DriverVehdetailsComponent } from './admin/vehicles/DriversAndVehicles/DriverVehdetails.component'

import { dataRectifyComponent } from './dataRectify/dataRectify.component'
import { weighbridgeDataComponent } from './dataRectify/weighbridgeData/weighbridgeData.component'
import { plantDataComponent } from './dataRectify/weighbridgeData/plantData/plantData.component'
import { tsDataComponent } from './dataRectify/weighbridgeData/tsData/tsData.component'
import { PlantComponentTest } from './reports/plant/plantReportTest.component'
import { EInvoicingComponent } from './crm/kcc/e-invoicing/e-invoicing.component'
import { VehDeploymentComponent } from './admin/vehicles/deploymentUploader/veh-deployment.component'
import { CompleteDashboardComponent } from './reports/uccReport/completeDashboard.component'
import { KMEntriesComponent } from './reports/fleet-report/km.component'
import { FleetReportsComponent } from './reports/fleet-report/fleetReport.component'
import { InvoiceUploaderComponent } from './crm/kcc/invoice-uploader/invoice-uploader.component'
import { khattaPointsComponent } from './maptracker/stop/khatta.component'
import { FuelUserComponent } from './superAdmin/users/fuelUser.component'
import { KmEntryFormComponent } from './reports/fleet-report/kmEntryForm.component'
import { LiveTrackingComponent } from './maptracker/live-tracking/live-tracking.component'
import { VtsStatusComponent } from './superAdmin/users/vtsStatus.component'
import { ItAssetComponent } from './superAdmin/users/itAsset.component'

import { ipWhitlistComponent } from './superAdmin/users/ipWhitlist.component'

import { LocationMgt } from './iswmMgt/Location/locations.component'

import { deviceDetailsMgt } from './iswmMgt/custom/deviceDetails.component'

//    Search All repots

import { allReportsComponent } from './AllReports/Reports/allReports.component'
import { allReportsMainComponent } from './AllReports/allReportsMain.component'

import { maintenanceSummaryComponent } from './maintenance/maintenanceSummary/maintenanceSummary.component'
import { maintenanceSummaryDashboardComponent } from './maintenance/maintenanceSummary/maintenanceSummaryDashboard/maintenanceSummaryDashboard.component'

import { MaintenanceSummaryBriefComponent } from './maintenance/maintenanceSummary/maintenanceSummaryDashboard/summary.component'
import { AssetReportComponent } from './reports/itAsset/asset.component'
import { AssetIssueDetailsReportComponent } from './reports/itAsset/assetIssueDetails.components'
import { AssetMasterDetailsReportComponent } from './reports/itAsset/assetMasterDetails.components'

// import { FuelTempComponent } from './reports/fuel/fuelTemp.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    component: HomeComponent,
    children: [
      { path: '', redirectTo: 'maptracker', pathMatch: 'full' },
      // searching data
      {
        path: 'searchingsokething',
        component: allReportsMainComponent,
        children: [
          { path: '', redirectTo: 'search', pathMatch: 'full' },

          {
            path: 'search',
            component: allReportsComponent,
          },
        ],
      },

      {
        path: 'maptracker',
        component: MaptrackerComponent,
        canActivate: [AuthGuard],
        data: { permission: 'maptracker.active' },

        children: [
          { path: '', redirectTo: 'vehicles', pathMatch: 'full' },

          // {
          // 	path: 'beat',
          // 	component: BeatComponent,
          // 	canActivate: [AuthGuard],
          // 	data: { permission: 'maptracker.beat.active' }
          // },

          // {
          // 	path: 'area',
          // 	component: AreaComponent,
          // 	canActivate: [AuthGuard],
          // 	data: { permission: 'maptracker.area.active' }
          // },
          {
            path: 'dashboard',
            component: VehDashboardComponent,
          },
          {
            path: 'vehicles',
            component: VehiclesComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.vehicles.active' },
          },
          {
            path: 'vehicles',
            component: mcgVehiclesComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.mcgVehicles.active' },
          },
          {
            path: 'maptrackerDashboard',
            component: maptrackerDashboardComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.maptrackerDashboard.active' },
          },
          // { path: 'vehicle', component: mcgVehiclesComponent },

          { path: 'secondaryOps', component: SecondaryOpsComponent },
          {
            path: 'stop',
            component: StopComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.vehicles.active' },
          },
          {
            path: 'alarm',
            component: AlarmsComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.alarm.active' },
          },
          {
            path: 'uccPotential',
            component: UccPotentialComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.uccPotential.active' },
          },
          {
            path: 'khattaPoints',
            component: khattaPointsComponent, //khatta
            data: { permission: 'maptracker.khatta.active' },
          },
          {
            path: 'McgDashboard',
            component: McgDashboardComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.McgDashboard.active' },
          },
          {
            path: 'liveTracking',
            component: LiveTrackingComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.liveTracking.active' },
          },
          {
            path: 'previousVtsData',
            component: previousVtsData,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.liveTracking.active' },
          },
          {
            path: 'routes-assignments',
            component: RouteAssignment,
            canActivate: [AuthGuard],
            data: { permission: 'maptracker.vehicles.active' },
          },
        ],
      },

      // Dashboard
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { permission: 'dashboard.active' },
        children: [
          { path: '', redirectTo: 'ucc', pathMatch: 'full' },

          {
            path: 'ucc',
            component: UccComponent,
            canActivate: [AuthGuard],
            data: { permission: 'dashboard.ucc.active' },
          },

          {
            path: 'complain',
            component: ComplainDashBoardComponent,
            canActivate: [AuthGuard],
            data: { permission: 'dashboard.complain.active' },
          },

          {
            path: 'project',
            component: ProjectComponent,
            canActivate: [AuthGuard],
            data: { permission: 'dashboard.project.active' },
          },
          {
            path: 'projectSummary',
            component: ProjectSummaryComponent,
            canActivate: [AuthGuard],
            data: { permission: 'dashboard.projectSummary.active' },
          },
          {
            path: 'targetDashboard',
            component: TargetDashBoardComponent,
            canActivate: [AuthGuard],
            data: { permission: 'dashboard.targetDashboard.active' },
          },
          {
            path: 'tonnageDashboard',
            component: TonnageDashBoardComponent,
            canActivate: [AuthGuard],
            data: { permission: 'dashboard.tonnageDashboard.active' },
          },
        ],
      },

      // {path: 'alarm', loadChildren: './alarms/alarms.module#AlarmsModule'},

      // alarm
      {
        path: 'alarm',
        component: AlarmComponent,
        canActivate: [AuthGuard],
        data: { permission: 'alarm.active' },
        children: [
          { path: '', redirectTo: 'alarmFuel', pathMatch: 'full' },
          //{ path: 'alarmSummary',  component:  AlarmSummaryComponent,canActivate: [AuthGuard] },
          {
            path: 'alarmFuel',
            component: AlarmFuelComponent,
            canActivate: [AuthGuard],
            data: { permission: 'alarm.alarmFuel.active' },
          },
          {
            path: 'fuelAlert',
            component: FuelAlertComponent,
            canActivate: [AuthGuard],
            data: { permission: 'alarm.alarmFuel.active' },
          },
        ],
      },

      // rectify
      {
        path: 'dataRectify',
        component: dataRectifyComponent,
        canActivate: [AuthGuard],
        data: { permission: 'dataRectify.active' },
        children: [
          { path: '', redirectTo: 'weighbridgeData', pathMatch: 'full' },
          {
            path: 'weighbridgeData',
            component: weighbridgeDataComponent,
            canActivate: [AuthGuard],
            data: { permission: 'dataRectify.weighbridgeData.active' },
            children: [
              { path: '', redirectTo: 'plantData', pathMatch: 'full' },
              {
                path: 'plantData',
                component: plantDataComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'dataRectify.weighbridgeData.plantData.active',
                },
              },
              {
                path: 'tsData',
                component: tsDataComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'dataRectify.weighbridgeData.tsData.active',
                },
              },
            ],
          },
          // {
          // 	path: 'fuelAlert',
          // 	component: FuelAlertComponent,
          // 	canActivate: [AuthGuard],
          // 	data: { permission: 'alarm.alarmFuel.active' }
          // }
        ],
      },

      //Admin Management
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [AuthGuard],
        data: { permission: 'admin.active' },
        children: [
          { path: '', redirectTo: 'vehicles', pathMatch: 'full' },
          {
            path: 'vehicles',
            component: VehComponent,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: 'vehicles', pathMatch: 'full' },
              {
                path: 'vehicles',
                component: VehicleComponent,
                canActivate: [AuthGuard],
                data: { permission: 'admin.vehicles.vehicles.active' },
              },
              {
                path: 'route-plans',
                component: RoutePlanComponent,
                canActivate: [AuthGuard],
                data: { permission: 'admin.vehicles.vehiclesRoutePlan.active' },
              },

              {
                path: 'vehiclesDeployment',
                component: VehDeploymentComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'admin.vehicles.vehiclesDeployment.active',
                },
              },
              {
                path: 'vehDriMasterData',
                component: DriverVehdetailsComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'admin.vehicles.vehiclesvehDriMasterData.active',
                },
              },
            ],
          },
          {
            path: 'employee',
            component: EmpComponent,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: 'employee', pathMatch: 'full' },
              {
                path: 'employee',
                component: EmployeeComponent,
                canActivate: [AuthGuard],
                data: { permission: 'admin.employee.employee.active' },
              },
              {
                path: 'driver',
                component: DriverComponent,
                canActivate: [AuthGuard],
                data: { permission: 'admin.employee.employee.active' },
              },
            ],
          },
          {
            path: 'entity',
            component: EntComponent,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: 'entity', pathMatch: 'full' },
              {
                path: 'entity',
                component: EntityComponent,
                canActivate: [AuthGuard],
                data: { permission: 'admin.entity.entity.active' },
              },
            ],
          },
          {
            path: 'hrms',
            component: HrmsComponent,
            canActivate: [AuthGuard],
            data: { permission: 'admin.hrms.active' },
            children: [
              { path: '', redirectTo: 'hrmsEmployee', pathMatch: 'full' },
              {
                path: 'hrmsEmployee',
                component: HrmsEmployeeComponent,
                canActivate: [AuthGuard],
                data: { permission: 'admin.hrms.hrmsEmployee.active' },
              },
            ],
          },
          {
            path: 'target',
            component: TargetComponent,
            canActivate: [AuthGuard],
            data: { permission: 'admin.target.active' },
            children: [
              { path: '', redirectTo: 'targetMaster', pathMatch: 'full' },
              {
                path: 'targetMaster',
                component: TargetMasterComponent,
                canActivate: [AuthGuard],
                data: { permission: 'admin.target.targetMaster.active' },
              },
            ],
          },
        ],
      },

      //########This Router for Super Admin Management START###########//
      {
        path: 'superAdmin',
        component: SuperAdminComponent,
        canActivate: [AuthGuard],
        data: { permission: 'superAdmin.active' },
        children: [
          { path: '', redirectTo: 'users', pathMatch: 'full' },
          {
            path: 'users',
            component: UsersComponent,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.users.active' },
          },

          {
            path: 'accessDetails',
            component: AccessDetailsComponent,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.accessDetails.active' },
          },

          {
            path: 'serverMonitoring',
            component: ServerMonitoring,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.serverMonitoring.active' },
          },
          {
            path: 'fuelUser',
            component: FuelUserComponent,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.fuelUsers.active' },
          },
          {
            path: 'uccUser',
            component: UccUserComponent,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.uccUser.active' },
          },
          {
            path: 'vtsStatusSuperAdmin',
            component: VtsStatusComponent,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.vtsStatusSuperAdmin.active' },
          },
          {
            path: 'itAssetSuperAdmin',
            component: ItAssetComponent,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.itAssetSuperAdmin.active' },
          },
          {
            path: 'ipWhitlist',
            component: ipWhitlistComponent,
            canActivate: [AuthGuard],
            data: { permission: 'superAdmin.ipWhitlist.active' },
          },
        ],
      },
      //########This Router for Super Admin Management END###########//

      // reports
      {
        path: 'reports',
        component: ReportsComponent,

        children: [
          { path: '', redirectTo: 'uccReport', pathMatch: 'full' },
          {
            path: 'uccReport',
            component: UccReportsComponent,
            children: [
              { path: '', redirectTo: 'uccDashboard', pathMatch: 'full' },
              // {
              // 	path: 'bulkCollectionReport',
              // 	component: BulkCollectionReportComponent,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.bulkCollectionReport.active' }
              // },
              // {
              // 	path: 'collectionAnalysisReport',
              // 	component: CollectionAnalysisReport,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.collectionAnalysisReport.active' }
              // },
              // {
              // 	path: 'collectionSummary',
              // 	component: CollectionSummaryComponent,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.collectionSummary.active' }
              // },
              // {
              // 	path: 'couponCollection',
              // 	component: CollectionReportComponent,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.couponCollection.active' }
              // },
              // {
              // 	path: 'uccCollection',
              // 	component: UccCollectionReportComponent,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.uccCollection.active' }
              // },
              {
                path: 'uccTransaction',
                component: UccTransactionComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.uccReport.transaction.active' },
              },
              {
                path: 'uccMapping',
                component: UccMappingComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.uccReport.uccUsers.active' },
              },
              // {
              // 	path: 'uccTransactionReprint',
              // 	component: UccTransactionReprintComponent,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.reprint.active' }
              // },
              // {
              // 	path: 'uccDefaulter',
              // 	component: UccDefaulterComponent,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.transaction.active' }
              // },
              {
                path: 'uccDashboard',
                component: UccDashboardComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.uccReport.dashboard.active' },
              },
              {
                path: 'uccUsers',
                component: UccUsersComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.uccReport.uccUsers.active' },
              },
              // {
              // 	path: 'completeDashboard',
              // 	component: CompleteDashboardComponent,
              // 	canActivate: [AuthGuard],
              // 	data: { permission: 'reports.uccReport.completeDashboard.active' }
              // }
            ],
          },
          //{ path: 'reports', component: ReportsComponent ,canActivate: [AuthGuard]},
          {
            path: 'kccReport',
            component: KccReportsComponent,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: 'kccSummaryReport', pathMatch: 'full' },
              {
                path: 'kccSummaryReport',
                component: KccSummaryReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.kccReport.kccSummaryReport.active',
                },
              },
              {
                path: 'kccCustomerReport',
                component: KccCustomerReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.kccReport.kccCustomerReport.active',
                },
              },
              {
                path: 'kccDetailReport',
                component: KccDetailReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.kccReport.kccDetailReport.active',
                },
              },
              {
                path: 'kccConsolidatedReport',
                component: KccConsolidatedReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.kccReport.kccConsolidatedReport.active',
                },
              },
              {
                path: 'kccDashboard',
                component: KccDashboardComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.kccReport.kccDashboard.active' },
              },
            ],
          },
          {
            path: 'fleet',
            component: FleetReportsComponent,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: 'fleetReport', pathMatch: 'full' },
              {
                path: 'fleetReport',
                component: KMEntriesComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.fleet.fleetReport.active' },
              },
              {
                path: 'kmEntryForm',
                component: KmEntryFormComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.fleet.kmEntryForm.active' },
              },
            ],
          },
          {
            path: 'entityReport',
            component: EntitysComponent,
            children: [
              { path: '', redirectTo: 'entitySummary', pathMatch: 'full' },
              {
                path: 'entitySummary',
                component: EntitySummaryReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.entityReport.entitySummary.active',
                },
              },
            ],
          },
          //Mobility Report cr by ram on 24-08-2018
          {
            path: 'mobilityReport',
            component: MobilityReportComponent,
            children: [
              { path: '', redirectTo: 'serviceReport', pathMatch: 'full' },
              {
                path: 'serviceReport',
                component: ServiceReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.mobilityReport.serviceReport.active',
                },
              },
              {
                path: 'surveyReport',
                component: SurveyReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.mobilityReport.surveyReport.active',
                },
              },
              {
                path: 'mappingReport',
                component: MappingReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.mobilityReport.mappingReport.active',
                },
              },
              {
                path: 'wmDispatchReport',
                component: WmDispatchComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.mobilityReport.wmDispatchReport.active',
                },
              },
            ],
          },
          {
            path: 'vtsReport',
            component: VtsReportsComponent,
            children: [
              { path: '', redirectTo: 'distanceReport', pathMatch: 'full' },
              {
                path: 'Driver',
                component: DriverVehicleComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.vtsReport.distanceReport.active' },
              },
              {
                path: 'distanceReport',
                component: DistanceComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.vtsReport.distanceReport.active' },
              },
              {
                path: 'vtsDailyReport',
                component: VtsDailyReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.vtsReport.vtsDailyReport.active' },
              },
              {
                path: 'vehStopReport',
                component: VehicleStopDetailComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.vtsReport.vehStopReport.active' },
              },
              {
                path: 'disFuel',
                component: DistanceFuelComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.vtsReport.vtsDailyReport.active' },
              },
              {
                path: 'vtsStatusDailyCount',
                component: VtsStatusDailyCountComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.vtsReport.vtsStatusDailyCount.active',
                },
              },
              {
                path: 'routeCoverReport',
                component: routeCoverReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.vtsReport.routeCoverReport.active',
                },
              },
              {
                path: 'secondaryReport',
                component: secondaryReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.vtsReport.secondaryReport.active',
                },
              },
            ],
          },

          {
            path: 'crmReport',
            component: CrmReportComponent,
            children: [
              { path: '', redirectTo: 'complainReport', pathMatch: 'full' },
              {
                path: 'complainReport',
                component: ComplainReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.crmReport.complainReport.active' },
              },
            ],
          },

          {
            path: 'plant',
            component: VehiclePlantComponent,
            children: [
              { path: '', redirectTo: 'plant', pathMatch: 'full' },
              {
                path: 'plant',
                component: PlantComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.plantReport.materialIn.active' },
              },
              {
                path: 'plantTest',
                component: PlantComponentTest,
                canActivate: [AuthGuard],
                data: { permission: 'reports.plantReport.plantTest.active' },
              },
              {
                path: 'transferStation',
                component: TransferStationComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.plantReport.materialOut.active' },
              },
              // weighbridgeDeatsils

              {
                path: 'weighbridgeDeatsils',
                component: weighbridgeDeatsils,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.plantReport.weighbridgeDeatsils.active',
                },
              },

              {
                path: 'manualFileUpload',
                component: manualFileUpload,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.plantReport.manualFileUpload.active',
                },
              },

              {
                path: 'rdfcompost',
                component: RdfComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.plantReport.materialOut.active' },
              },
              {
                path: 'pcts',
                component: PctsComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.plantReport.pcts.active' },
              },
              {
                path: 'transferStationDataView',
                component: transferStationDataView,
                canActivate: [AuthGuard],
                data: {
                  permission:
                    'reports.plantReport.transferStationDataView.active',
                },
              },

              {
                path: 'transferStationDetails',
                component: transferStationDetails,
                canActivate: [AuthGuard],
                data: {
                  permission:
                    'reports.plantReport.transferStationDetails.active',
                },
              },
            ],
          },
          {
            path: 'vehicleReport',
            component: VehicleReport,
            children: [
              {
                path: '',
                redirectTo: 'primaryVehicleReport',
                pathMatch: 'full',
              },
              //{ path: 'tripReport', component: TripReportComponent,canActivate: [AuthGuard],data :{permission: 'reports.vtsReport.tripReport.active' ' }},
              {
                path: 'primaryVehicleReport',
                component: PrimaryVehicleReport,
                canActivate: [AuthGuard],
                data: {
                  permission:
                    'reports.vehicleReport.primaryVehicleReport.active',
                },
              },
              {
                path: 'primaryLiveTrackingReport',
                component: PrimaryliveTrackingReport,
              },
              {
                path: 'primaryVehicleTripReport',
                component: PrimaryVehicleTripReport,
              },
              {
                path: 'primaryUnservedAreaReport',
                component: PrimaryUnservedAreaReport,
              },
              {
                path: 'primaryVehAssignment',
                component: PrimaryAssignmentComponent,
                canActivate: [AuthGuard],
                data: {
                  permission:
                    'reports.vehicleReport.primaryVehAssignment.active',
                },
              },
            ],
          },
          {
            path: 'secondary',
            component: SecondaryReport,
            children: [
              {
                path: '',
                redirectTo: 'secondaryLiveTrackingReport',
                pathMatch: 'full',
              },
              {
                path: 'secondaryLiveTrackingReport',
                component: SecondaryliveTrackingReport,
                canActivate: [AuthGuard],
                data: {
                  permission:
                    'reports.secondary.secondaryLiveTrackingReport.active',
                },
              },
              {
                path: 'secondaryAssignment',
                component: SecondaryAssignmentComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.secondary.secondaryAssignment.active',
                },
              },
            ],
          },
          {
            path: 'fuel',
            component: FuelReportComponent,
            canActivate: [AuthGuard],
            data: { permission: 'reports.fuel.active' },
            children: [
              { path: '', redirectTo: 'fuelMasterReport', pathMatch: 'full' },
              {
                path: 'vehicleFuel',
                component: FuelPurchaseReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.fuel.vehicleFuel.active' },
              },
              {
                path: 'looseFuel',
                component: FuelLooseReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.fuel.looseFuel.active' },
              },
              {
                path: 'fuelDistribution',
                component: FuelDistributionReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.fuel.fuelDistribution.active' },
              },
              {
                path: 'fuelMileageReport',
                component: MileageReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.fuel.fuelMileageReport.active' },
              },
              {
                path: 'fuelMasterReport',
                component: FuelMasterReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.fuel.fuelMasterComponent.active' },
              },
              {
                path: 'graphicalViewReport',
                component: GraphicalVievComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.fuel.graphicalViewComponent.active',
                },
              },
            ],
          },
          {
            path: 'attendance',
            component: AttendComponent,
            canActivate: [AuthGuard],
            data: { permission: 'reports.attendance.active' },
            children: [
              { path: '', redirectTo: 'attendanceReport', pathMatch: 'full' },
              {
                path: 'attendanceDeatil',
                component: AttendanceDeatilComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.attendance.attendanceDeatil.active',
                },
              },
              {
                path: 'attendanceReport',
                component: AttendanceReportComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'reports.attendance.attendanceReport.active',
                },
              },
            ],
          },
          {
            path: 'cost',
            component: CostControlComponent,
            canActivate: [AuthGuard],
            data: { permission: 'reports.cost.active' },
            children: [
              { path: '', redirectTo: 'costCombined', pathMatch: 'full' },
              {
                path: 'costCombined',
                component: CombbinedReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.cost.costCombined.active' },
              },
            ],
          },
          {
            path: 'hr',
            component: HrComponent,
            canActivate: [AuthGuard],
            data: { permission: 'reports.hr.active' },
            children: [
              { path: '', redirectTo: 'ecokra', pathMatch: 'full' },
              {
                path: 'ecokra',
                component: EcokraComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.hr.ecokra.active' },
              },
            ],
          },
          {
            path: 'doortodoor',
            component: DoorToDoorComponent,
            canActivate: [AuthGuard],
            data: { permission: 'reports.doortodoor.active' },
          },

          {
            path: 'asset',
            component: AssetReportComponent,
            canActivate: [AuthGuard],
            data: { permission: 'reports.asset.active' },
            children: [
              { path: '', redirectTo: 'assetDeatils', pathMatch: 'full' },
              {
                path: 'assetIssueDeatils',
                component: AssetIssueDetailsReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.asset.assetDeatils.active' },
              },
              {
                path: 'assetDeatils',
                component: AssetMasterDetailsReportComponent,
                canActivate: [AuthGuard],
                data: { permission: 'reports.asset.assetIssueDeatils.active' },
              },
            ],
          },
        ],
      },

      // crm
      {
        path: 'crm',
        component: CRMComponent,
        children: [
          //KCC Route KccComponent
          { path: '', redirectTo: 'kcc', pathMatch: 'full' },
          {
            path: 'kcc',
            component: KccComponent,
            children: [
              { path: '', redirectTo: 'consumerList', pathMatch: 'full' },
              {
                path: 'consumerList',
                component: ConsumerListComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kcc.consumerList.active' },
              },

              {
                path: 'invoiceList',
                component: InvoiceListComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kcc.invoiceList.active' },
              },
              {
                path: 'bankMst',
                component: BankmstComponent,
              },
              {
                path: 'kccReq',
                component: KccReqComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kcc.kccReq.active' },
              },
              {
                path: 'UploaderComp',
                component: InvoiceUploaderComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kcc.UploaderComp.active' },
              },
              {
                path: 'eInvoice',
                component: EInvoicingComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kcc.eInvoice.active' },
              },
              {
                path: 'createInvoice/:consumerCode/:invoiceNo',
                component: CreateInvoiceComponent,
              },
              {
                path: 'paymentList',
                component: PaymentListComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kcc.payment.active' },
              },
            ],
          },

          { path: 'kccLko', redirectTo: 'consumerListLko', pathMatch: 'full' },
          {
            path: 'kccLko',
            component: KccLkoComponent,
            children: [
              { path: '', redirectTo: 'consumerListLko', pathMatch: 'full' },
              {
                path: 'consumerListLko',
                component: ConsumerListLkoComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kccLko.consumerListLko.active' },
              },

              {
                path: 'invoiceListLko',
                component: InvoiceListLkoComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kccLko.invoiceListLko.active' },
              },
              {
                path: 'createInvoiceLko/:consumerCode/:invoiceNo',
                component: CreateInvoiceLkoComponent,
              },
              {
                path: 'paymentListLko',
                component: PaymentListLkoComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.kccLko.paymentLko.active' },
              },
            ],
          },

          { path: 'complain', redirectTo: 'complainList', pathMatch: 'full' },
          {
            path: 'complain',
            component: ComplainComponent,
            children: [
              { path: '', redirectTo: 'complainList', pathMatch: 'full' },
              {
                path: 'complainList',
                component: ComplainListComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.complain.active' },
              },
            ],
          },
          //New CRM UCC (24-102018)
          {
            path: 'ucc',
            component: CrmUccComponent,
            children: [
              { path: '', redirectTo: 'grn', pathMatch: 'full' },
              {
                path: 'grn',
                component: GrnComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.grn.active' },
              },
              {
                path: 'couponAssignment',
                component: CouponAssignComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.couponAssignment.active' },
              },
              {
                path: 'couponCollection',
                component: CouponCollectionComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.couponCollection.active' },
              },
              {
                path: 'couponReturn',
                component: CouponReturnComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.couponReturn.active' },
              },
              {
                path: 'couponMissing',
                component: CouponMissingComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.couponMissing.active' },
              },
              {
                path: 'inventorySummary',
                component: InventorySummaryComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.inventorySummary.active' },
              },
              {
                path: 'inventoryDetail',
                component: InventoryDetailComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.inventoryDetail.active' },
              },
              {
                path: 'collectionReceived',
                component: CollectionReceivedComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.collectionReceived.active' },
              },
              {
                path: 'bulkCouponCollection',
                component: BulkCouponCollectionComponent,
                canActivate: [AuthGuard],
                data: { permission: 'crm.ucc.bulkCouponCollection.active' },
              },
            ],
          },
        ],
      },

      // maintenance
      {
        path: 'maintenance',
        component: MaintenanceComponent,
        children: [
          { path: '', redirectTo: 'maintenanceSummary', pathMatch: 'full' },
          {
            path: 'vehicleMaintenance',
            component: VehicleMaintMntComponent,
            children: [
              { path: '', redirectTo: 'vehicleMaintenance', pathMatch: 'full' },
              {
                path: 'vehicleMaintenance',
                component: VehicleMaintenanceComponent,
                canActivate: [AuthGuard],
                data: {
                  permission:
                    'maintenance.vehicleMaintenance.vehicleMaintenance.active',
                },
              },
              {
                path: 'logbook',
                component: LogbookComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'maintenance.vehicleMaintenance.logbook.active',
                },
              },
              {
                path: 'substitute-vehicles',
                component: SubstituteComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'maintenance.vehicleMaintenance.logbook.active',
                },
              },
              {
                path: 'maintenance-approval',
                component: VehMaintenanceApprovalComponent,
                canActivate: [AuthGuard],
                // data: { permission: 'maintenance.vehicleMaintenance.maintenanceApproval.active' }
              },
              {
                path: 'JobCardApproval',
                component: jobCardApprovalComponent,
                canActivate: [AuthGuard],
                data: {
                  permission:
                    'maintenance.vehicleMaintenance.JobCardApproval.active',
                },
              },
            ],
          },
          {
            path: 'maintenanceStatus/:vehicleNo',
            component: VehMaintStatusComponent,
          },
          {
            path: 'ts',
            component: TsComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maintenance.ts.active' },
            children: [
              { path: '', redirectTo: 'tsMaster', pathMatch: 'full' },
              {
                path: 'tsMaster',
                component: TsMasterComponent,
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.ts.tsMaster.active' },
              },
              {
                path: 'tslogBook',
                component: TSLogbookComponent,
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.ts.tslogBook.active' },
              },
              {
                path: 'tsMaintenance',
                component: TsMaintenanceComponent,
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.ts.tsMaintenance.active' },
              },
            ],
          },
          {
            path: 'part',
            component: PartComponent,
            canActivate: [AuthGuard],
            children: [
              {
                path: '',
                redirectTo: 'partMaster',
                pathMatch: 'full',
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.part.active' },
              },
              {
                path: 'partMaster',
                component: PartMasterComponent,
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.part.partMaster.active' },
              },
              {
                path: 'PartDashboard',
                component: PartDashboardComponent,
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.part.PartDashboard.active' },
              },
              {
                path: 'vendorMaster',
                component: VendorMasterComponent,
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.part.vendorMaster.active' },
              },
              {
                path: 'invoiceAndChallan',
                component: invoiceAndChallanComponent,
                canActivate: [AuthGuard],
                data: {
                  permission: 'maintenance.part.invoiceAndChallan.active',
                },
              },
            ],
          },
          {
            path: 'EO',
            component: EngineComponent,
            canActivate: [AuthGuard],
            data: { permission: 'maintenance.EO.active' },
            children: [
              { path: '', redirectTo: 'engineOil', pathMatch: 'full' },
              {
                path: 'engineOil',
                component: EngineoilComponent,
                canActivate: [AuthGuard],
                data: { permission: 'maintenance.EO.engineOil.active' },
              },
            ],
          },
          {
            path: 'maintenanceSummary',
            component: maintenanceSummaryComponent,
            canActivate: [AuthGuard],
            // data: { permission: 'maintenance.maintenanceSummary.active' },
            children: [
              {
                path: '',
                redirectTo: 'MaintenanceSummaryBriefComponent',
                pathMatch: 'full',
              },
              {
                path: 'MaintenanceSummaryBriefComponent',
                component: MaintenanceSummaryBriefComponent,
                canActivate: [AuthGuard],
                // data: { permission: 'maintenance.maintenanceSummary.maintenanceSummaryDashBoard.active' }
              },
            ],
          },
        ],
      },

      // mobility
      {
        path: 'mobility',
        component: MobilityComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'khattaReport', pathMatch: 'full' },
          {
            path: 'khattaReport',
            component: KhattaServiceReportComponent,
            canActivate: [AuthGuard],
            data: { permission: 'mobility.khattaReport.active' },
          },
          {
            path: 'user',
            component: MobilityUserComponent,
            canActivate: [AuthGuard],
            data: { permission: 'mobility.user.active' },
          },
        ],
      },

      {
        path: 'iSWM',
        component: IswmComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'locations', pathMatch: 'full' },
          {
            path: 'locations',
            component: LocationMgt,
            canActivate: [AuthGuard],
            data: { permission: 'iSWM.users.active' },
          },

          {
            path: 'device',
            component: deviceDetailsMgt,
            canActivate: [AuthGuard],
            data: { permission: 'iSWM.users.active' },
          },
        ],
      },
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
]
@NgModule({
  imports: [CommonModule, BrowserModule, RouterModule.forRoot(routes)],
  exports: [],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts